import { Injectable } from '@angular/core';
import { CrudService } from '../../services';
import { Invoice } from '../../dto/invoice';
import { HttpParams, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from '../../../../node_modules/rxjs';
import { DataListModel } from '../../models/data-list-model';
import { WebIdTransaction } from '../../dto/web-id-transaction';

@Injectable({
  providedIn: 'root'
})
export class WebIdTransactionService {

  readonly apiPath = 'web-id/transactions/';

  constructor(private http: HttpClient) { }

  getAttachment( transactionId: number ): Observable<HttpResponse<Blob>> {
    return this.http.get( this.apiPath + transactionId + '/response-file', { params: null, responseType: 'blob', observe: 'response' } );
  }

}
